import * as THREE from 'three';
import { ThresholdEffect } from '../effects/ThresholdEffect.js';

export class Starfield extends THREE.Group {
    constructor() {
        super();
        this.stars = [];
        this.movementType = null;
        this.createStars();
        
        // Add threshold effect
        this.thresholdEffect = new ThresholdEffect();
        this.add(this.thresholdEffect);
    }

    createStars() {
        const starCount = 500; // Reduced count to 500
        const clearRadius = 10; // Radius of clear area around pod
        const sphereGeometry = new THREE.SphereGeometry(0.1, 8, 8);
        const material = new THREE.MeshBasicMaterial({
            color: 0xffffff,
            transparent: true,
            opacity: 0.8
        });

        for (let i = 0; i < starCount; i++) {
            let radius, theta, x, y;
            
            // Keep generating positions until we find one outside the clear area
            do {
                radius = Math.random() * 50;
                theta = Math.random() * Math.PI * 2;
                x = Math.cos(theta) * radius;
                y = Math.sin(theta) * radius;
            } while (Math.sqrt(x * x + y * y) < clearRadius);

            const depth = -100 + Math.random() * 95; // Random depth between -100 and -5
            const speed = 0.3 * (1 - depth / -100); // Speed between 0.06 and 0.3

            const star = new THREE.Mesh(sphereGeometry, material.clone());
            star.position.set(x, y, depth);
            star.speed = speed;
            
            // Random slight variations in size
            const scale = 0.8 + Math.random() * 0.4; // 0.8 to 1.2
            star.scale.setScalar(scale);

            this.add(star);
            this.stars.push(star);
        }
    }

    setMoving(isMoving) {
        this.isMoving = isMoving;
    }

    update(movementType) {
        if (!movementType) return;
        
        // Update threshold effect
        if (this.thresholdEffect) {
            this.thresholdEffect.update();
        }
        
        const clearRadius = 10;
        const moveSpeed = movementType === 'dunyawi' ? 2 : 1; // Doubled speeds
        
        this.stars.forEach(star => {
            if (movementType === 'dunyawi') {
                // Forward movement for Dunyawi (reversed direction)
                star.position.z -= star.speed * moveSpeed;
                
                // Reset stars that go too far away
                if (star.position.z < -100) {
                    // Trigger threshold effect
                    if (!star.crossedThreshold) {
                        this.thresholdEffect.trigger();
                        star.crossedThreshold = true;
                    }
                    
                    let x, y;
                    do {
                        const radius = Math.random() * 50;
                        const theta = Math.random() * Math.PI * 2;
                        x = Math.cos(theta) * radius;
                        y = Math.sin(theta) * radius;
                    } while (Math.sqrt(x * x + y * y) < clearRadius);

                    star.position.set(x, y, 5);
                    star.crossedThreshold = false;
                }
            } else if (movementType === 'briolissens') {
                // Orbital movement for Briolissens
                const rotationSpeed = star.speed * moveSpeed * 0.02;
                const radius = Math.sqrt(star.position.x * star.position.x + star.position.z * star.position.z);
                const currentAngle = Math.atan2(star.position.z, star.position.x);
                const newAngle = currentAngle + rotationSpeed;
                
                star.position.x = Math.cos(newAngle) * radius;
                star.position.z = Math.sin(newAngle) * radius;
            }
        });
    }
}
